import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `TripletexIntegration` is an implementation of `AbstractIntegration`
 * for integration with Tripletex.
 *
 * @param {boolean} spec.includeInvoices - Specifies if invoices should be imported or not.
 */
export default class TripletexIntegration extends AbstractIntegration {
	constructor({ includeInvoices = true } = {}) {
		super(...arguments);

		this._includeInvoices = includeInvoices;
	}

	isBeta() {
		return false;
	}

	getName() {
		return "Tripletex";
	}

	routeName() {
		return "tripletex";
	}

	hasInvoiceSupport() {
		return true;
	}

	isTripletexIntegration() {
		return true;
	}

	shouldImportInvoices() {
		return this._includeInvoices;
	}

	canHaveLinkedDocuments() {
		return true;
	}

	static getType() {
		return "TripletexIntegration";
	}
}
